import { render } from "./SetAuth.vue?vue&type=template&id=60c7d78c"
import script from "./SetAuth.vue?vue&type=script&lang=js"
export * from "./SetAuth.vue?vue&type=script&lang=js"

import "./SetAuth.vue?vue&type=style&index=0&id=60c7d78c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__